import { render, staticRenderFns } from "./manuscript_premium_button.vue?vue&type=template&id=618d82e0&scoped=true"
import script from "./manuscript_premium_button.vue?vue&type=script&lang=js"
export * from "./manuscript_premium_button.vue?vue&type=script&lang=js"
import style0 from "./manuscript_premium_button.vue?vue&type=style&index=0&id=618d82e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d82e0",
  null
  
)

export default component.exports